import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	var wrappers = document.querySelectorAll('[data-p360-counters]');
	if (!wrappers.length || !('IntersectionObserver' in window)) {
		return;
	}

	var duration = 1200; // ms
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function animateValue(el) {
		var target = parseFloat(el.getAttribute('data-count'));
		var suffix = el.getAttribute('data-suffix') || '';

		if (reduceMotion || isNaN(target)) {
			return; // leave the server-rendered final value as-is
		}

		var start = null;

		function step(timestamp) {
			if (start === null) {
				start = timestamp;
			}
			var progress = Math.min((timestamp - start) / duration, 1);
			var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
			el.textContent = Math.round(target * eased) + suffix;

			if (progress < 1) {
				window.requestAnimationFrame(step);
			} else {
				el.textContent = target + suffix;
			}
		}

		el.textContent = '0' + suffix;
		window.requestAnimationFrame(step);
	}

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) {
				return;
			}
			entry.target.classList.add('is-visible');
			entry.target
				.querySelectorAll('[data-count]')
				.forEach(animateValue);
			observer.unobserve(entry.target);
		});
	}, { threshold: 0.4 });

	wrappers.forEach(function (wrapper) {
		observer.observe(wrapper);
	});
});